import React from "react";
import Button from "../button/Button";

export default function Navbar() {
  return (
    <div className="navbar">
      <Button label={"Countdown"} route={"/"} />
      <Button label={"Groups"} route={"/groups"} />
      <Button label={"Rules"} route={"/rules"} />
      <Button label={"Schedule"} route={"/schedules"} />
    </div>
  );
}
